export function inventoryCountRooms(values) {
    const rooms = ["Front Room", "Back Room"]
    for (const value of Array.isArray(values) ? values : []) {
        if (typeof value !== "string" || !value.trim()) continue
        const name = value.trim()
        if (!rooms.some(room => room.toLowerCase() === name.toLowerCase())) rooms.push(name)
    }
    return rooms
}
